// Simple browser logger to replace winston for client-side use
const isProduction = process.env.NODE_ENV === 'production';

const logger = {
  info: (...args) => {
    if (!isProduction) if (!isProduction) console.info(...args);
  },
  warn: (...args) => {
    if (!isProduction) console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
  debug: (...args) => {
    if (!isProduction) if (!isProduction) console.debug(...args);
  },
  log: (...args) => {
    if (!isProduction) if (!isProduction) console.log(...args);
  }
};

// User activity logging
logger.user = (action, userId, details = {}) => {
  logger.info(`User ${action}`, { userId, action, ...details });
};

// Component lifecycle logging (for debugging only)
logger.component = (componentName, action, details = {}) => {
  logger.debug(`Component ${componentName}: ${action}`, { component: componentName, action, ...details });
};

// API request logging
logger.api = (method, endpoint, details = {}) => {
  logger.info(`API ${method} ${endpoint}`, { method, endpoint, ...details });
};

// API error logging
logger.apiError = (method, endpoint, error, details = {}) => {
  logger.error(`API Error: ${method} ${endpoint}`, {
    method,
    endpoint,
    errorMessage: error?.message,
    stack: !isProduction ? error?.stack : undefined,
    ...details
  });
};

// Auth related logging
logger.auth = (action, details = {}) => {
  logger.info(`Auth: ${action}`, { action, ...details });
};


// User activity logging
logger.user = (action, userId, details = {}) => {
  logger.info(`User ${action}`, {
    userId,
    action,
    ...details
  });
};

// Component lifecycle logging (for debugging only)
logger.component = (componentName, action, details = {}) => {
  logger.debug(`Component ${componentName}: ${action}`, {
    component: componentName,
    action,
    ...details
  });
};

// API request logging
logger.api = (method, endpoint, details = {}) => {
  logger.info(`API ${method} ${endpoint}`, {
    method,
    endpoint,
    ...details
  });
};

// API error logging
logger.apiError = (method, endpoint, error, details = {}) => {
  logger.error(`API Error: ${method} ${endpoint}`, {
    method,
    endpoint,
    errorMessage: error.message,
    stack: !isProduction ? error.stack : undefined,
    ...details
  });
};

// Auth related logging
logger.auth = (action, details = {}) => {
  logger.info(`Auth: ${action}`, {
    action,
    ...details
  });
};

// Capture uncaught errors and unhandled promise rejections in the browser
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    logger.error('Uncaught error', {
      message: event.message,
      source: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    logger.error('Unhandled promise rejection', {
      reason: event.reason?.message || event.reason,
      stack: event.reason?.stack
    });
  });
}

export default logger;